import { createFetch } from "../../../../../helpers/fetch/FetchRequest";
import { getCookie } from "../../../../../helpers/common";
import { authNotify, onAuthError, saveLocationForRedirect } from "../../../../../helpers/data/get/user";
import { API_OWN_CMD_EXTERNAL } from "../../../../../settings/endpoints/user";
import { USER_ACCESS_TOKEN_NAME } from "../../../../../settings/global";


export function getCommand(onSuccess, onError) {
    createFetch({
        URL: API_OWN_CMD_EXTERNAL,
        headers: {'Authorization': 'Bearer ' + getCookie(USER_ACCESS_TOKEN_NAME)},
        onSuccess: data => {
            if (onSuccess) onSuccess(data.cmd)
        },
        onError: response => {
            if (response.status === 401) {
                saveLocationForRedirect();
                onAuthError();
                authNotify();
                return;
            }
            if (onError) onError(response)
        }
    })
}